@if (isTextarea) {
<textarea #inputElement z-input [zSize]="size" [zStatus]="status" [zBorderless]="borderless" [placeholder]="placeholder"
    [disabled]="disabled" [readonly]="readonly" [required]="required" [attr.maxlength]="maxlength"
    [attr.minlength]="minlength" [attr.id]="id" [rows]="rows" [cols]="cols" [class]="class" [value]="value"
    (input)="onInput($event)" (blur)="onBlur($event)" (focus)="onFocus($event)"></textarea>
} @else {
<input #inputElement z-input [type]="type" [zSize]="size" [zStatus]="status" [zBorderless]="borderless"
    [placeholder]="placeholder" [disabled]="disabled" [readonly]="readonly" [required]="required"
    [attr.maxlength]="maxlength" [attr.minlength]="minlength" [attr.min]="min" [attr.max]="max" [attr.id]="id"
    [class]="class" [value]="value" (input)="onInput($event)" (blur)="onBlur($event)" (focus)="onFocus($event)" />
}
